// IDEA: probably do tooltip instead of flash

export default function initCopyable() {
  document.addEventListener(`click`, (e) => {
    const target = e.target.closest(`[data-copyable]`)

    if (!target) return

    const copyable = (target.dataset.copyable || ``).trim()
    if (!copyable) return

    window.navigator.clipboard.writeText(copyable)

    const { copyableFlashText } = window.NaturkartanConfig || {}
    if (copyableFlashText)
      window.liveSocketPutFlash?.(`info`, copyableFlashText)
  })
}
